<template>
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 13.92L11.7333 9.684C12.378 8.67736 12.7197 7.50668 12.718 6.31133C12.72 2.832 9.86667 0 6.36 0C2.85267 0 0 2.832 0 6.312C0 9.79267 2.85267 12.6247 6.35933 12.6247C7.50288 12.6262 8.62567 12.3192 9.60933 11.736L13.9053 16L16 13.92ZM2.36933 6.312C2.36933 4.13 4.15933 2.35333 6.35867 2.35333C8.55867 2.35333 10.348 4.12933 10.348 6.312C10.348 8.49533 8.558 10.2713 6.35867 10.2713C4.15933 10.2713 2.36933 8.49533 2.36933 6.312Z"
      fill="#585266"
    />
  </svg>
</template>

<script>
export default {
  name: 'ChatListSearchIcon'
}
</script>
